import { localized } from "@msuite/ui/localization";
import { moment } from "@msuite/utils/date";
import { formatNumber } from "@msuite/utils/numbers";
import { calculateTourWaveCutoffTime } from "@msuite/utils/stock";
import type { Tables } from "@msuite/utils/types";

/** Props Interface */
interface TourWaveCutoffOffsetHintProps {
	item: Tables<"tourWaves">;
}

export function TourWaveCutoffOffsetHint({ item }: TourWaveCutoffOffsetHintProps) {
	const startTime = moment().setTime(item.startTime);
	const calculatedCutoffTime = calculateTourWaveCutoffTime(
		moment().setTime(item.startTime),
		item.cutoffOffset,
	);

	const isSameDate = startTime.isSame(calculatedCutoffTime, "date");
	const text = isSameDate
		? localized("dates.on_the_same_day_at")
		: localized("dates.on_the_previous_workday_at");

	const formatted = calculatedCutoffTime.format("HH:mm[h]");

	return `${text} ${formatted} (${formatNumber(item.cutoffOffset)}h)`;
}
